'use client';

import { c as _c } from "react/compiler-runtime";
import './child-bio-image.scss';
import { useTranslation } from 'react-i18next';
import { HtmlBlock } from '@sola/ark-core/atoms/html/html.tsx';
import { ChildImageVariantEnum, getChildImageUrl } from '@sola/ark-core/utils/child-image.ts';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { Image } from '../../atoms/image/image.tsx';
import { useSacImageAltText } from '../../utils/alt-text.ts';
import placeholder from './placeholder.png';
type ChildBioImageProps = {
  availability: ChildAvailabilityItem;
  details: ChildDetails;
  aspectRatio?: string;
  childImageVariant?: ChildImageVariantEnum;
  caption?: string;
  centerCaption?: boolean;
  width?: number;
};
export const ChildBioImage = t0 => {
  const $ = _c(28);
  const {
    details,
    availability,
    aspectRatio: t1,
    childImageVariant: t2,
    caption,
    centerCaption: t3,
    width: t4
  } = t0;
  const aspectRatio = t1 === undefined ? "3-4" : t1;
  const childImageVariant = t2 === undefined ? ChildImageVariantEnum.Full : t2;
  const centerCaption = t3 === undefined ? false : t3;
  const width = t4 === undefined ? 500 : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["bio", "children", "geo"];
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const {
    t
  } = useTranslation(t5);
  const {
    imageUrl,
    name,
    hangul
  } = details;
  const {
    gender,
    isSpecialNeeds,
    isOrphan,
    isInHivAffectedArea,
    minDaysWaiting,
    icp: t6
  } = availability;
  const {
    country
  } = t6;
  let t7;
  if ($[1] !== childImageVariant || $[2] !== imageUrl || $[3] !== width) {
    t7 = getChildImageUrl(imageUrl, childImageVariant, width);
    $[1] = childImageVariant;
    $[2] = imageUrl;
    $[3] = width;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const childImage = t7;
  const titleAndAlt = useSacImageAltText(gender, country, hangul, minDaysWaiting, name.preferred, isOrphan, isSpecialNeeds, isInHivAffectedArea);
  let t8;
  if ($[5] !== caption || $[6] !== hangul || $[7] !== minDaysWaiting || $[8] !== name.preferred || $[9] !== t) {
    t8 = caption ?? t("bio:waitingCaption", {
      childName: name.preferred,
      koreanName: hangul.preferred,
      days: minDaysWaiting
    });
    $[5] = caption;
    $[6] = hangul;
    $[7] = minDaysWaiting;
    $[8] = name.preferred;
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const captionText = t8;
  const t9 = childImage || placeholder as unknown as string;
  let t10;
  if ($[11] !== t9 || $[12] !== titleAndAlt) {
    t10 = {
      url: t9,
      alt: titleAndAlt
    };
    $[11] = t9;
    $[12] = titleAndAlt;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== aspectRatio || $[15] !== childImage || $[16] !== t10) {
    t11 = <Image key={childImage} image={t10} lazyLoad="eager" aspectRatio={aspectRatio} className="ChildBioImage__Figure__img" />;
    $[14] = aspectRatio;
    $[15] = childImage;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== centerCaption) {
    t12 = cn("ChildBioImage__Figure__figcaption label label-xl", {
      "text-center": centerCaption
    });
    $[18] = centerCaption;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== captionText) {
    t13 = <HtmlBlock htmlString={captionText} />;
    $[20] = captionText;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13) {
    t14 = <figcaption className={t12}>{t13}</figcaption>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14) {
    t15 = <div className="ChildBioImage xl:pr-comfy-xl"><figure className="ChildBioImage__Figure">{t11}{t14}</figure></div>;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};